module.exports = "<h1 translate>Access is denied</h1> <p class=type-h5 translate>You do not have permission to view this page.</p> <p class=type-h5 translate>Contact <a href=mailto:support@profficina.be class=link>support@profficina.be</a> for further assistance.</p> <p>Error 401 - Unauthorized</p> <br/>";


//////////////////
// WEBPACK FOOTER
// ./features/authorization/unauthorized.html
// module id = 565
// module chunks = 0